import PartnerRiskLevelRepository from '@/repository/generatedRepository/partnerRiskLevelRepository'
import { defaultFilters } from '@/models/Country/helpers'
import TableOptions from '@/models/TableOptions'

const state = {
  list: [],
  filters: { ...defaultFilters() },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  list: state => state.list,
  isOpenFilterPanel: state => state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadPartnerRiskLevel(context, filters) {
    context.commit('setFilters', filters)
    const { data } = await PartnerRiskLevelRepository.getRiskLevel(filters)
    context.commit('setList', { data, filters })
    return { items: data }
  },
}

const mutations = {
  setList(state, { data, filters }) {
    state.list = [...data]
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
